import { 
  createUserWithEmailAndPassword, 
  updateProfile 
} from 'firebase/auth';
import { doc, setDoc } from 'firebase/firestore';
import { auth, db } from '../firebase/config';
import { Member, Admin } from '../types';

// Script d'initialisation des données
export class InitDataService {
  
  // Créer un utilisateur admin par défaut
  static async createDefaultAdmin() {
    try {
      const adminEmail = 'admin@asprocom.com';
      const adminPassword = 'asprocom2024!';
      
      // Créer l'utilisateur
      const userCredential = await createUserWithEmailAndPassword(
        auth, 
        adminEmail, 
        adminPassword
      );
      
      // Mettre à jour le profil
      await updateProfile(userCredential.user, {
        displayName: 'Administrateur ASPROCOM'
      });
      
      // Créer le document admin dans Firestore
      const adminData: Admin = {
        id: userCredential.user.uid,
        email: adminEmail,
        name: 'Administrateur ASPROCOM',
        role: 'super_admin',
        permissions: ['all'],
        createdAt: new Date()
      };
      
      await setDoc(doc(db, 'admins', userCredential.user.uid), adminData);
      
      console.log('✅ Admin créé avec succès !');
      console.log(`📧 Email: ${adminEmail}`);
      console.log(`🔑 Mot de passe: ${adminPassword}`);
      
      return userCredential.user;
      
    } catch (error: any) {
      if (error.code === 'auth/email-already-in-use') {
        console.log('ℹ️ L\'admin existe déjà');
        return null;
      }
      console.error('❌ Erreur lors de la création de l\'admin:', error);
      throw error;
    }
  }
  
  // Créer un membre de test
  static async createTestMember() {
    try {
      const memberEmail = 'membre@asprocom.com';
      const memberPassword = 'membre2024!';
      
      // Créer l'utilisateur
      const userCredential = await createUserWithEmailAndPassword(
        auth, 
        memberEmail, 
        memberPassword
      );
      
      // Mettre à jour le profil
      await updateProfile(userCredential.user, {
        displayName: 'Membre Test ASPROCOM'
      });
      
      // Créer le document membre dans Firestore
      const memberData: Member = {
        id: userCredential.user.uid,
        email: memberEmail,
        firstName: 'Membre',
        lastName: 'Test',
        membershipStatus: 'active',
        hasVotingRights: true,
        memberSince: new Date(),
        lastActive: new Date()
      };
      
      await setDoc(doc(db, 'members', userCredential.user.uid), memberData);
      
      console.log('✅ Membre test créé avec succès !');
      console.log(`📧 Email: ${memberEmail}`);
      console.log(`🔑 Mot de passe: ${memberPassword}`);
      
      return userCredential.user;
      
    } catch (error: any) {
      if (error.code === 'auth/email-already-in-use') {
        console.log('ℹ️ Le membre test existe déjà');
        return null;
      }
      console.error('❌ Erreur lors de la création du membre test:', error);
      throw error;
    }
  }
  
  // Initialiser toutes les données de base
  static async initAll() {
    console.log('🚀 Initialisation des données...');
    
    try {
      await this.createDefaultAdmin();
      await this.createTestMember();
      
      console.log('✅ Initialisation terminée !');
      console.log('\n📋 Comptes créés :');
      console.log('👑 Admin: admin@asprocom.com / asprocom2024!');
      console.log('👤 Membre: membre@asprocom.com / membre2024!');
      
    } catch (error) {
      console.error('❌ Erreur lors de l\'initialisation:', error);
    }
  }
}
